export const ROUTE_NAMES = {
  DASHBOARD: 'dashboard',
  PROFILE: 'profile',
  CLIENT_EMPLOYEES: 'clientEmployees',
  CLIENT_EMPLOYEE_DETAIL: 'clientEmployeeDetail',
  TIMESHEET: 'timesheet',
  HOURS: 'hours',
  PAYROLL: 'payroll',
  REPORTS: 'reports',
} as const;

export const ROUTE_PATHS = {
  DASHBOARD: '/',
  PROFILE: '/profile',
  CLIENT_EMPLOYEES: '/client-employees',
  TIMESHEET: '/timesheet',
  HOURS: '/hours',
  PAYROLL: '/payroll',
  REPORTS: '/reports',
} as const;
